import { render, staticRenderFns } from "./OPGeneral.vue?vue&type=template&id=5cbe38ae&"
import script from "./OPGeneral.vue?vue&type=script&lang=js&"
export * from "./OPGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports